const ADMIN_ROLE_NAME = "admin";
const SESSION_ROLE_KEY = "role";
const SESSION_ADMIN_KEY = "is_admin_user";

function normalize_role_name(role_name) {
  return String(role_name || "")
    .toLowerCase()
    .replace(/_/g, " ")
    .trim();
}

function get_backend_role_name(user) {
  return user?.user_role?.role?.name || "";
}

function has_django_admin_flag(user) {
  return user?.is_superuser === true || user?.is_staff === true;
}

function has_cached_admin_flag() {
  return sessionStorage.getItem(SESSION_ADMIN_KEY) === "true";
}

export function is_admin_user(user) {
  const backend_role_name = get_backend_role_name(user);
  const cached_role_name = sessionStorage.getItem(SESSION_ROLE_KEY);
  const role_name = normalize_role_name(backend_role_name || cached_role_name);

  return has_django_admin_flag(user) || has_cached_admin_flag() || role_name === ADMIN_ROLE_NAME;
}
